/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionMaterialConsumptionBase } from "../../../../schema/generated/ConstructionMaterialConsumption";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionMaterialConsumptionDataApi extends EntityDataApi<ConstructionMaterialConsumptionBase> {
  public readonly def = idbEntityDefs.ConstructionMaterialConsumption;
}